const trabajadorNotificacion = {
  isLoading: false,
  listCompanyNotifications: null,
  listWorkerNotifications: null,
};

export default trabajadorNotificacion;

